export enum MeetingType {
    Board = "Board",
    Independent_Directors = "Independent Directors",
    Annual_General_Meeting = "Annual General Meeting",
    Extraordinary_General_Meeting = "Extraordinary General Meeting",
    Postal_Ballot = "Postal Ballot",
    Others = "Others"
}
